"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./TrashCanIcon"), exports);
tslib_1.__exportStar(require("./TrashCanIcon16Light"), exports);
tslib_1.__exportStar(require("./TrashCanIcon16Regular"), exports);
tslib_1.__exportStar(require("./TrashCanIcon16Solid"), exports);
tslib_1.__exportStar(require("./TrashCanIcon20Light"), exports);
tslib_1.__exportStar(require("./TrashCanIcon20Regular"), exports);
tslib_1.__exportStar(require("./TrashCanIcon20Solid"), exports);
tslib_1.__exportStar(require("./TrashCanIcon24Regular"), exports);
tslib_1.__exportStar(require("./TrashCanIcon24Solid"), exports);
tslib_1.__exportStar(require("./TrashCanIcon32Regular"), exports);
tslib_1.__exportStar(require("./TrashCanIcon64Regular"), exports);
